/**
 * API client for model management endpoints.
 * Routes: /api/mgmt/models
 */

import { apiFetch } from './client';

export interface ModelInfo {
  id?: string;
  mode?: string;
  supports_vision?: boolean;
  supports_function_calling?: boolean;
  supports_parallel_function_calling?: boolean;
  max_tokens?: number;
  max_input_tokens?: number;
  max_output_tokens?: number;
  [key: string]: unknown;
}

export interface LitellmParams {
  model: string;
  api_base?: string;
  api_key?: string;
  [key: string]: unknown;
}

export interface Model {
  model_name: string;
  litellm_params: LitellmParams;
  model_info: ModelInfo;
  provider?: string;
  created_at?: string;
}

export interface AddModelData {
  modelName: string;
  litellmModel: string;
  apiBase?: string;
  apiKey?: string;
  accountId?: string;
  tpm?: number;
  rpm?: number;
}

export async function listModels(token: string): Promise<Model[]> {
  const data = await apiFetch<{ models: Model[] }>('/api/mgmt/models', token);
  return Array.isArray(data) ? data : (data.models ?? []);
}

export async function addModel(data: AddModelData, token: string): Promise<Record<string, unknown>> {
  return apiFetch<Record<string, unknown>>('/api/mgmt/models', token, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateModel(
  modelId: string,
  data: Record<string, unknown>,
  token: string,
): Promise<Record<string, unknown>> {
  return apiFetch<Record<string, unknown>>(
    `/api/mgmt/models/${encodeURIComponent(modelId)}`,
    token,
    {
      method: 'PUT',
      body: JSON.stringify(data),
    },
  );
}

export async function deleteModel(modelId: string, token: string): Promise<void> {
  return apiFetch<void>(
    `/api/mgmt/models/${encodeURIComponent(modelId)}`,
    token,
    {
      method: 'DELETE',
    },
  );
}
